import Api from './api.service'

const baseURL = process.env.VUE_APP_API_PAGE

export default {
  getList () {
    return Api().get(baseURL + '/backend/page')
  },
  get (page) {
    return Api().get(`${baseURL}/backend/page/${page}`)
  },
  store (page, payload) {
    return Api().post(`${baseURL}/backend/page`, payload)
  },
  update (page, payload) {
    return Api().post(`${baseURL}/backend/page/${page}`, payload)
  },
  delete (page) {
    return Api().delete(`${baseURL}/backend/page/${page}`)
  },
  reorder (payload) {
    return Api().post(`${baseURL}/backend/page/reorder`, payload)
  },
  getSections (page) {
    return Api().get(`${baseURL}/backend/page/${page}/sections`)
  },
  storeSection (page, payload) {
    return Api().post(`${baseURL}/backend/page/${page}/sections`, payload)
  },
  updateSection (page, id, payload) {
    return Api().post(`${baseURL}/backend/page/${page}/section/${id}`, payload)
  },
  deleteSection (id) {
    return Api().delete(`${baseURL}/backend/section/${id}`)
  },
  getElements (page) {
    return Api().get(`${baseURL}/backend/page/${page}/elements`)
  },
  removeElement (id) {
    return Api().delete(`${baseURL}/backend/widget/${id}`)
  },
  getBlogPosts () {
    return Api().get(baseURL + '/backend/blog')
  },
  getBlogPost (id) {
    return Api().get(`${baseURL}/backend/blog/${id}`)
  },
  deleteBlogPost (post) {
    return Api().delete(`${baseURL}/backend/blog/${post}`)
  },
  storeBlogPost (payload) {
    return Api().post(`${baseURL}/backend/blog`, payload)
  },
  getNodes () {
    return Api().get(baseURL + '/backend/node')
  },
  getConfig () {
    return Api().get(baseURL + '/backend/config')
  },
  storeConfig (payload) {
    return Api().put(baseURL + '/backend/config', payload)
  },
  getLanguages () {
    return Api().get(baseURL + '/backend/config?key=multilanguage')
  },
  getPressReleaseList () {
    return Api().get(baseURL + '/backend/press')
  },
  getPressRelease (id) {
    return Api().get(`${baseURL}/backend/press/${id}`)
  },
  storePressRelease (payload) {
    return Api().post(`${baseURL}/backend/press`, payload)
  },
  reorderPressReleases (payload) {
    return Api().post(`${baseURL}/backend/press/reorder`, payload)
  }
}
